<template>
  <div>
    <span
      v-if="mode !== 'form'"
      class="has-text-grey"
      style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px"
    >
      {{ setting.label || name }}
    </span>
    <el-select
      filterable
      v-model="value[name]"
      placeholder="Select"
      :name="setting.label || name"
      :clearable="setting.clearable"
      style="margin-bottom: 1em; width: 360px"
    >
      <el-option
        v-for="item in setting.options"
        :key="item.value"
        :label="item.label"
        :value="item.value ? item.value : item.label"
      >
        <span :style="{ float: 'left' }">{{ item.label }}</span>
        <span
          v-if="setting.displayValue"
          class="has-text-grey"
          :style="{
            float: 'right',
            color: item.color ? item.color : '',
            fontSize: 13 + 'px',
            marginLeft: '1.5em',
          }"
        >
          {{ item.value ? item.value : item.label }}
        </span>
      </el-option>
    </el-select>

    <Tooltip :label="setting.label || name" :content="setting.detail" />
  </div>
</template>

<script>
/**
 * Select SmartField - Renders a single-select dropdown for configuration values.
 *
 * @component
 * @description Displays a filterable dropdown with options. Can optionally display both label and value,
 * and supports clearing the selection. Options can have custom colors for the value display.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the select (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Array<Object>} setting.options - Array of options to display
 * @prop {string} setting.options[].label - Display text for the option
 * @prop {string} [setting.options[].value] - Value for the option (defaults to label)
 * @prop {string} [setting.options[].color] - Color for the value text
 * @prop {boolean} [setting.displayValue] - If true, shows the value alongside the label
 * @prop {boolean} [setting.clearable] - If true, allows clearing the selection
 * @prop {*} [setting.default] - Default value if not set
 * @prop {string} name - Property key in the value object
 * @prop {string} [mode] - Display mode ('form' hides label)
 *
 * @example
 * <Select
 *   :value="config"
 *   :setting="{
 *     label: 'Language',
 *     detail: 'Select language',
 *     options: [{ label: 'English', value: 'en' }, { label: 'Spanish', value: 'es' }],
 *     clearable: true
 *   }"
 *   name="language"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name", "mode"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
